import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "code",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "rate",
    label: "currency_rate",
    type: "money",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return <ResourceListPage url="currencies" columns={columns} />;
}
